module.exports = __webpack_public_path__ + "images/learn-future-proof.webp";